const FakeSelect = () => {

  const el = {
    root: document.querySelectorAll('.fake-select'),
  };

  const method = {
    init: () => {
      Array.prototype.forEach.call(el.root, (item) => {
        item.querySelector('.fake-select__trigger').addEventListener('click', (e) => {
          const itm = e.target.parentNode
          itm.classList.toggle('open')
        })
      })
    }
  };

  method.init();
};

export default FakeSelect;